var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubtract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 166,
    viewBox: "0 0 166 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.0887 16.1311L106.91 23.9524L59.0054 23.9524L66.8267 16.1311H99.0887ZM91.2674 8.30975L82.9577 7.32658e-05L74.648 8.30975L91.2674 8.30975ZM51.184 31.7737L114.731 31.7737L122.553 39.595L43.3627 39.595L51.184 31.7737ZM35.5414 47.4164L130.374 47.4164L138.195 55.2377L27.7201 55.2377L35.5414 47.4164ZM19.8988 63.059L146.017 63.059L153.838 70.8803L12.0775 70.8803L19.8988 63.059ZM4.25613 78.7016L161.659 78.7016L165.915 82.9578L162.35 86.5229L3.56519 86.5229L0 82.9578L4.25613 78.7016ZM11.3865 94.3443L154.529 94.3443L146.708 102.166L19.2078 102.166L11.3865 94.3443ZM138.886 109.987L27.0292 109.987L34.8505 117.808L131.065 117.808L138.886 109.987ZM123.244 125.63L42.6718 125.63L50.4931 133.451L115.422 133.451L123.244 125.63ZM107.601 141.272L58.3144 141.272L66.1357 149.094L99.7796 149.094L107.601 141.272ZM91.9583 156.915L73.9571 156.915L82.9577 165.915L91.9583 156.915Z",
    fill: "#FF5800",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtract);
export default __webpack_public_path__ + "static/media/subtract.a75a7be1bf974c5e78fd5dd5a1f63379.svg";
export { ForwardRef as ReactComponent };